export const SET_CART_DETAIL = 'SET_CART_DETAIL';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_TILES = 'SET_TILES';
export const SET_SUB_CATEGORIES = 'SET_SUB_CATEGORIES';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_PRODUCT_DETAIL = 'SET_PRODUCT_DETAIL';
export const SET_STORE_DETAIL = 'SET_STORE_DETAIL';
export const SET_SHIPPING_CHARGES = 'SET_SHIPPING_CHARGES';
export const SET_ORDER_DETAIL = 'SET_ORDER_DETAIL';
export const SET_PAYMENT_INFO = 'SET_PAYMENT_INFO';
export const SET_RECENT_ORDER = 'SET_RECENT_ORDER';
export const SET_ZONEWISE_DELIVERYCHARGES = 'SET_ZONEWISE_DELIVERYCHARGES';
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export const SET_BIRDBUCK_COUPON = 'SET_BIRDBUCK_COUPON';
export const SET_TAXES = 'SET_TAXES';
export const SET_STORE_LOCATIONS = 'SET_STORE_LOCATIONS';
export const SET_USER_SHIPPING_ZONE_INFO = 'SET_USER_SHIPPING_ZONE_INFO';
export const SET_SUBSCRIPTIONS = 'SET_SUBSCRIPTIONS';
export const SET_SUBSCRIPTIONS_DETAIL = 'SET_SUBSCRIPTIONS_DETAIL';
export const SET_AVAILABLE_SUBSCRIPTIONS_INTERVAL = 'SET_AVAILABLE_SUBSCRIPTIONS_INTERVAL';
export const SET_SUBSCRIBABLE_PRODUCTS = 'SET_SUBSCRIBABLE_PRODUCTS';
export const SET_SUBSCRIPTION_CONFIG = 'SET_SUBSCRIPTION_CONFIG';
export const SET_DISCOUNT_COUPON = 'SET_DISCOUNT_COUPON';
export const SET_PROMO_IMAGE = 'SET_PROMO_IMAGE';
export const SET_STORE_FEATURE = 'SET_STORE_FEATURE';
export const SET_BIRDBUCKS_BY_USER = 'SET_BIRDBUCKS_BY_USER';
export const SET_STORE_DISCOUNT_MAP = 'SET_STORE_DISCOUNT_MAP';
export const SET_REFERRAL_PRODUCTS = 'SET_REFERRAL_PRODUCTS';
export const SET_ORDER_POINTS = 'SET_ORDER_POINTS';
export const SET_GIFT_CARDS = 'SET_GIFT_CARDS';
export const SET_ERPLY_BIRDBUCKS_BY_USER = 'SET_ERPLY_BIRDBUCKS_BY_USER';
export const SET_BASE_SHIPPING_CHARGE = 'SET_BASE_SHIPPING_CHARGE';

export default {
  SET_CART_DETAIL,
  SET_CATEGORIES,
  SET_TILES,
  SET_SUB_CATEGORIES,
  SET_PRODUCTS,
  SET_PRODUCT_DETAIL,
  SET_STORE_DETAIL,
  SET_SHIPPING_CHARGES,
  SET_ORDER_DETAIL,
  SET_PAYMENT_INFO,
  SET_RECENT_ORDER,
  SET_ZONEWISE_DELIVERYCHARGES,
  SET_SEARCH_RESULTS,
  SET_BIRDBUCK_COUPON,
  SET_TAXES,
  SET_STORE_LOCATIONS,
  SET_USER_SHIPPING_ZONE_INFO,
  SET_SUBSCRIPTIONS,
  SET_SUBSCRIPTIONS_DETAIL,
  SET_AVAILABLE_SUBSCRIPTIONS_INTERVAL,
  SET_SUBSCRIBABLE_PRODUCTS,
  SET_SUBSCRIPTION_CONFIG,
  SET_DISCOUNT_COUPON,
  SET_PROMO_IMAGE,
  SET_STORE_FEATURE,
  SET_BIRDBUCKS_BY_USER,
  SET_STORE_DISCOUNT_MAP,
  SET_REFERRAL_PRODUCTS,
  SET_ORDER_POINTS,
  SET_GIFT_CARDS,
  SET_ERPLY_BIRDBUCKS_BY_USER,
  SET_BASE_SHIPPING_CHARGE
};



// WEBPACK FOOTER //
// ./src/app/order/action-types.js